export default __webpack_public_path__ + "static/img4-34cdb089f9be5cbaaa0516977806dec6.png";